var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLensIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.823 22.013h-1.506l-.533-.54c1.932-2.354 2.994-5.358 2.992-8.466 0-2.572-.727-5.087-2.088-7.226-1.36-2.14-3.296-3.806-5.56-4.79A11.84 11.84 0 0 0 9.972.25c-2.403.502-4.61 1.74-6.343 3.56a13.221 13.221 0 0 0-3.39 6.66 13.613 13.613 0 0 0 .705 7.515c.938 2.377 2.525 4.408 4.563 5.838a11.973 11.973 0 0 0 6.882 2.192c3.069 0 5.89-1.18 8.062-3.142l.514.56v1.581L30.494 35l2.84-2.982-9.51-10.005Zm-11.435 0c-4.746 0-8.576-4.023-8.576-9.006 0-4.982 3.83-9.005 8.576-9.005s8.576 4.023 8.576 9.005c0 4.983-3.83 9.006-8.576 9.006Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensIcon);
export default __webpack_public_path__ + "static/media/lens-icon.e2454374.svg";
export { ForwardRef as ReactComponent };